
  import { Component, Vue } from "vue-property-decorator";
  import LzButton from "@/components/Button.vue";
  import LzBox from "@/components/Box.vue";
  import { namespace } from "vuex-class";
  import { apiOngs } from "../api";
  const auth = namespace("auth");

  @Component({
    components: { LzButton, LzBox }
  })
  export default class Home extends Vue {
    @auth.State("id")
    public ongId!: string;
    balance = "0";
    netBalance = "0";
    features = {};
    plan = {} as any;
    free = false;
    name = "";

    mounted() {
      apiOngs.getOng(this.ongId).then(({ data }) => {
        this.name = data.name;
        apiOngs.getWallet(data.walletId).then(response => {
          this.balance = response.availableBalance.toString();
          this.netBalance = (
            parseInt(this.balance) -
            parseInt(this.balance) * 0.05
          ).toString();
        });
      });
      apiOngs.getPlatformFeatures(this.ongId).then(({ data }) => {
        this.features = data;
      });
      apiOngs.getOrganizationPlan(this.ongId).then(({ data }) => {
        this.plan = data;

        if (
          data.PlatformSubscription?.id ==
          "c02645a9-108a-4541-a031-c1a67593960e"
        ) {
          this.free = true;
        }
      });
    }
  }
